<script lang="ts">
import { defineComponent } from 'vue'

import { opChain } from '@collector/shared-utils'
import { BasketballIncidentId } from '@collector/sportsapi-client-legacy'
import IncidentButton from '@mobile/views/Relation/Shared/IncidentButton/IncidentButton.vue'

import { useBasketBallConfiguration } from '../../BasketballRelationDependencies/useBasketBallConfiguration'

export default defineComponent({
  components: { IncidentButton },
  setup() {
    const { activeParticipant, inactiveParticipant } =
      useBasketBallConfiguration()

    return {
      activeParticipant,
      inactiveParticipant,
      BasketballIncidentId,
      opChain,
    }
  },
})
</script>

<template>
  <div class="grid gap-4">
    <IncidentButton
      class="h-full"
      :type="'horizontal'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.TwoPointShotMissed"
    >
      <div class="flex w-full items-center justify-between">
        <span>2pts</span>
        <FontAwesomeIcon
          class="text-red text-lg"
          icon="times"
        />
      </div>
    </IncidentButton>
    <IncidentButton
      class="h-full"
      :type="'horizontal'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.ThreePointShotMissed"
    >
      <div class="flex w-full items-center justify-between">
        <span>3pts</span>
        <FontAwesomeIcon
          class="text-red text-lg"
          icon="times"
        />
      </div>
    </IncidentButton>
    <IncidentButton
      class="h-full"
      :type="'horizontal'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.FreeThrowMissed"
    >
      <div class="flex w-full items-center justify-between">
        <span>1pt</span>
        <FontAwesomeIcon
          class="text-red text-lg"
          icon="times"
        />
      </div>
    </IncidentButton>
  </div>
  <div class="grid gap-4">
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(inactiveParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.DefensiveRebound"
    >
      DR
    </IncidentButton>
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.OffensiveRebound"
    >
      OR
    </IncidentButton>
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(inactiveParticipant.participant, (v) => v.id)"
      :incidentId="BasketballIncidentId.Block"
    />
  </div>
</template>
